import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../../data/mockData';
import { Phone, Mail, MapPin, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1e3a52] text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-b from-[#5ba4c8] to-[#2c4a62] rounded-md flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 2.18l7 3.12v5.7c0 4.67-3.13 8.97-7 10.2-3.87-1.23-7-5.53-7-10.2V6.3l7-3.12z"/>
                  <path d="M12 6l-4 2v3c0 2.5 1.7 4.8 4 5.5 2.3-.7 4-3 4-5.5V8l-4-2z"/>
                </svg>
              </div>
              <span className="font-bold text-sm">BU SECURITY</span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Trusted Professional Security Guard Services in Florida. Reliable Protection for Businesses, Residential Properties, and Events.
            </p>
            <div className="flex gap-3">
              <a href={companyInfo.socialLinks.facebook} target="_blank" rel="noopener noreferrer"
                 className="w-8 h-8 bg-[#5ba4c8] rounded-full flex items-center justify-center hover:bg-[#4a93b7] transition-colors">
                <Facebook size={16} />
              </a>
              <a href={companyInfo.socialLinks.linkedin} target="_blank" rel="noopener noreferrer"
                 className="w-8 h-8 bg-[#5ba4c8] rounded-full flex items-center justify-center hover:bg-[#4a93b7] transition-colors">
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold mb-4 text-[#5ba4c8]">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white transition-colors">Industries</Link></li>
              <li><Link to="/quote" className="text-gray-400 hover:text-white transition-colors">Request a Quote</Link></li>
              <li><Link to="/employment" className="text-gray-400 hover:text-white transition-colors">Employment</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold mb-4 text-[#5ba4c8]">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/unarmed-guards" className="text-gray-400 hover:text-white transition-colors">Unarmed Guards</Link></li>
              <li><Link to="/services/armed-guards" className="text-gray-400 hover:text-white transition-colors">Armed Guards</Link></li>
              <li><Link to="/services/mobile-patrols" className="text-gray-400 hover:text-white transition-colors">Mobile Patrols</Link></li>
              <li><Link to="/services/event-security" className="text-gray-400 hover:text-white transition-colors">Event Security</Link></li>
              <li><Link to="/services/surveillance-monitoring" className="text-gray-400 hover:text-white transition-colors">Surveillance</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold mb-4 text-[#5ba4c8]">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-gray-400">
                <Phone size={16} className="text-[#5ba4c8]" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-white transition-colors">{companyInfo.phone}</a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail size={16} className="text-[#5ba4c8]" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-white transition-colors">{companyInfo.email}</a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={16} className="text-[#5ba4c8] mt-1" />
                <span>{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} Bu Security. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
